module.exports = __webpack_public_path__ + "media/images/grey-paul-da3dda5eba996451e9e5eea8603c4e3f.jpg";